export const availableLanguages = ['en-GB', 'pl'] as const;

export type Language = string

export const defaultLanguage: Language = 'en-GB';
